export default class SubscriptionStatusViewModel {
    public companyId: number = 0;
    public freeTrialEndDate: Date = new Date();
    public seatsInSubscription: number = 0;
    public trialDaysRemaining: number = 0;
    public status: string = ""; 
    public usedSeats: number = 0;
    public hasPaymentMethod: boolean = false;
}